import { render, staticRenderFns } from "./app-refresh.vue?vue&type=template&id=3bde100a&scoped=true&"
import script from "./app-refresh.vue?vue&type=script&lang=js&"
export * from "./app-refresh.vue?vue&type=script&lang=js&"
import style0 from "./app-refresh.vue?vue&type=style&index=0&id=3bde100a&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bde100a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/anatec/wesave/wesave-conseil-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('3bde100a', component.options)
    } else {
      api.reload('3bde100a', component.options)
    }
    module.hot.accept("./app-refresh.vue?vue&type=template&id=3bde100a&scoped=true&", function () {
      api.rerender('3bde100a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/authenticated/app-refresh.vue"
export default component.exports